const WEBSITE_CODE_PATTERNS = 'patterns';
const WEBSITE_CODE_MARKET = 'market';

const STORE_CODE_PATTERNS_ENGLISH = 'patterns_english';
const STORE_CODE_PATTERNS_NORWEGIAN = 'patterns_norwegian';

const STORE_CODE_MARKET_ENGLISH = 'market_english';
const STORE_CODE_MARKET_NORWEGIAN = 'market_norwegian';

type WebsiteCode = typeof WEBSITE_CODE_PATTERNS | typeof WEBSITE_CODE_MARKET;

type PatternsStoreCode =
    | typeof STORE_CODE_PATTERNS_ENGLISH
    | typeof STORE_CODE_PATTERNS_NORWEGIAN;

type MarketStoreCode =
    | typeof STORE_CODE_MARKET_ENGLISH
    | typeof STORE_CODE_MARKET_NORWEGIAN;

type StoreCode = PatternsStoreCode | MarketStoreCode;

type MagentoStoreCodeMap = {
    patterns: {
        en: typeof STORE_CODE_PATTERNS_ENGLISH;
        no: typeof STORE_CODE_PATTERNS_NORWEGIAN;
    };
    market: {
        en: typeof STORE_CODE_MARKET_ENGLISH;
        no: typeof STORE_CODE_MARKET_NORWEGIAN;
    };
};

const MAGENTO_STORE_CODES: MagentoStoreCodeMap = {
    patterns: {
        en: STORE_CODE_PATTERNS_ENGLISH,
        no: STORE_CODE_PATTERNS_NORWEGIAN,
    },
    market: {
        en: STORE_CODE_MARKET_ENGLISH,
        no: STORE_CODE_MARKET_NORWEGIAN,
    },
};

const getStoreCode = (
    websiteCode: WebsiteCode,
    language: LanguageCode,
): StoreCode => {
    return MAGENTO_STORE_CODES[websiteCode][language];
};

const getPatternsStoreCode = (language: LanguageCode): PatternsStoreCode => {
    return MAGENTO_STORE_CODES.patterns[language];
};

const getMarketStoreCode = (language: LanguageCode): MarketStoreCode => {
    return MAGENTO_STORE_CODES.market[language];
};

import useMagentoStoreCode from './useMagentoStoreCode';

export default useMagentoStoreCode;

export type { MarketStoreCode, PatternsStoreCode as PatternStoreCode };

export {
    MAGENTO_STORE_CODES,
    getStoreCode,
    getMarketStoreCode,
    getPatternsStoreCode,
};
